export default __webpack_public_path__ + "static/media/weprofile-96x96.05842b00.png";